import React from "react";
import Title from "../common/Title";
import img1 from "../../assets/img/destination-1.png";
import img2 from "../../assets/img/destination-2.png";
import img3 from "../../assets/img/destination-3.png";
import CustomButton from "../common/PrimaryBtn";

const Destination = () => {
  return (
    <div>
      <div className="container sm:px-5 px-4 mx-auto 2xl:max-w-[1240px] relative sm:pt-24 pt-20">
        <Title text="Discover Our Iconic Destinations" myClass="text-center" />
        <div className="flex mt-14 gap-5 xl:gap-0 flex-wrap xl:flex-nowrap justify-center">
          <div className="relative xl:max-w-[380px] lg:max-w-[340px] max-w-[330px] xl:-rotate-6 group ">
            <img className="w-full rounded-[20px]" src={img1} alt="img-1" />
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full text-white text-center pb-5 opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out">
              <h4 className="text-base font-semibold pb-2">Most popular</h4>
              <h4 className="text-[28px] font-semibold leading-[120%]">
                Hurawalhi Island
              </h4>
            </div>
          </div>
          <div className="relative xl:max-w-[380px] lg:max-w-[340px] max-w-[330px] z-10 group">
            <img className="w-full rounded-[20px]" src={img2} alt="img-1" />
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full text-white text-center pb-5 opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out">
              <h4 className="text-base font-semibold pb-2">Most popular</h4>
              <h4 className="text-[28px] font-semibold leading-[120%]">
                Hurawalhi Island
              </h4>
            </div>
          </div>
          <div className="relative xl:max-w-[380px] lg:max-w-[340px] max-w-[330px] xl:rotate-6 group">
            <img className="w-full rounded-[20px]" src={img3} alt="img-1" />
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full text-white text-center pb-5 opacity-0 group-hover:opacity-100 transition-all duration-300 ease-in-out">
              <h4 className="text-base font-semibold pb-2">Most popular</h4>
              <h4 className="text-[28px] font-semibold leading-[120%]">
                Hurawalhi Island
              </h4>
            </div>
          </div>
        </div>
        <div className="text-center xl:mt-10 mt-8">
          <CustomButton text="Explore All Destinations" />
        </div>
      </div>
    </div>
  );
};

export default Destination;
